/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import "./Footer.css";
import { Link, useNavigate } from "react-router-dom";
import { BsFacebook } from "react-icons/bs";
import { AiOutlineInstagram } from "react-icons/ai";
import { BiLogoLinkedin } from "react-icons/bi";
import { AiFillYoutube } from "react-icons/ai";
import { FaWhatsapp } from "react-icons/fa6";
import {
  COMPANY_ADDRESS,
  EMAIL_ADDRESS,
  FACEBOOK_URL,
  INSTGRAM_URL,
  LINKEDIN_URL,
  MOBILE_NUMBER,
  YOU_TUBE_URL,
} from "../../Constant/Global";
import ScrollToTopButton from "../ScrollToTopButton/ScrollToTopButton";
const Footer = () => {
  const navigate = useNavigate();
  const handleScrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return (
    <>
      <ScrollToTopButton />
      <div className="sidenav">
        <a
          href={`https://api.whatsapp.com/send?phone=${MOBILE_NUMBER}`}
          class="btn-whatsapp-pulse"
          target="_blank"
          style={{ cursor: "pointer" }}
        >
          <FaWhatsapp size={30} color="#fff" />
        </a>
      </div>
      <footer className="text-center text-lg-start footer-main text-muted">
        <section className="p-2">
          <div className="container-fluid text-center text-md-start mt-5">
            <div className="row text-white mt-3">
              <div className="col-sm-12 col-lg-5 mx-auto mb-4">
                <div className="footer-left-sec">
                  <div className="logo-reviews-sec mb-4">
                    <img
                      src={require("../../component/asset/image/skyflypark logo png.png")}
                      alt="f-logo"
                      className="me-3"
                      height={100}
                      width={100}
                    />
                    <div className="footer-reviews mt-3">
                      <p className="me-3 mt-3">| reviews </p>
                      <img
                        src={require("../../component/asset/image/f-reviews.png")}
                        alt="f-reviews"
                      />
                    </div>
                  </div>
                  <div className="f-news-letter">
                    <h6>News Letter</h6>
                    <p>
                      Subscribe to our newsletter to get our latest update &
                      news
                    </p>
                    <div className="email-btn-group">
                      <input type="email" placeholder="Email Address" />
                      <button>Send</button>
                    </div>
                    <div className="footer-ul-list">
                      <ul className="ps-0 ul-list-f">
                        <li>
                          Family amusement park with SkyFly Parks courses, plus
                          climbing walls, <br className="mobile-hidden" /> foam
                          pits & Zumba sessions.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3  col-md-6 col-sm-12 pe-0 footer-c-sec mb-4">
                <div className="quick-links-sec">
                  <h6 className="fw-bold  footer-c-text mb-0">Quick links</h6>
                  <hr />
                  <p className="footer-p">
                    <button
                      className="text-reset  text-decoration-none footer-links"
                      onClick={() => {
                        navigate("/");
                        handleScrollToTop();
                      }}
                    >
                      Home
                    </button>
                  </p>
                  <p className="footer-p">
                    <button
                      onClick={() => {
                        navigate("/about");
                        handleScrollToTop();
                      }}
                      className="footer-links"
                    >
                      About Us
                    </button>
                  </p>
                  <p className="footer-p">
                    <button
                      onClick={() => {
                        navigate("/offer_prices");
                        handleScrollToTop();
                      }}
                      className="text-reset  text-decoration-none footer-links"
                    >
                      Offer & Prices
                    </button>
                  </p>
                  <p className="footer-p">
                    <button
                      onClick={() => {
                        navigate("/activity_adventure");
                        handleScrollToTop();
                      }}
                      className="text-reset  text-decoration-none footer-links"
                    >
                      Activity & Adventure
                    </button>
                  </p>
                  <p className="footer-p">
                    <button
                      onClick={() => {
                        navigate("/photo_videos");
                        handleScrollToTop();
                      }}
                      className="text-reset  text-decoration-none footer-links"
                    >
                      Photos & Video
                    </button>
                  </p>
                  <p className="footer-p">
                    <button
                      onClick={() => {
                        navigate("/contact");
                        handleScrollToTop();
                      }}
                      className="text-reset  text-decoration-none footer-links"
                    >
                      Contact
                    </button>
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12 pe-0 ms-0 footer-c-sec mb-md-0 mb-4">
                <div className="footer-about w-100">
                  <h6 className="fw-bold footer-c-text mb-0">Address</h6>
                  <hr className="footer-hr" />

                  <p className="footer-p mb-2">{COMPANY_ADDRESS}</p>

                  <p className="footer-p mb-2">
                    <strong>Mobile:</strong>{" "}
                    <Link
                      to={`tel:${MOBILE_NUMBER}`}
                      className="footer-links ms-0"
                    >
                      +91 {MOBILE_NUMBER}
                    </Link>
                  </p>

                  <p className="footer-p mb-2">
                    <strong>Email:</strong>{" "}
                    <Link
                      to={`mailto:${EMAIL_ADDRESS}`}
                      className="footer-links ms-0"
                    >
                      {EMAIL_ADDRESS}
                    </Link>
                  </p>

                  <p className="footer-p mb-2">
                    <strong>Park Timings:</strong>
                    <br />
                    9:00 AM – 6:00 PM (Mon - Sun)
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="footer-bottom-main">
          <div className="copy-right-text">
            <h6>
              © {new Date().getFullYear()} SkyFly Park. Designed and developed
              by{" "}
              <Link target="_blank" to="https://microdynamicsoftware.com/">
                microdynamic software pvt. ltd.
              </Link>{" "}
              All rights reserved.
            </h6>
          </div>
          <div className="f-social-icons">
            <Link to={INSTGRAM_URL} target="_blank" className="social-links-f">
              <AiOutlineInstagram />
            </Link>
            <Link to={FACEBOOK_URL} target="_blank" className="social-links-f">
              <BsFacebook />
            </Link>
            <Link to={YOU_TUBE_URL} target="_blank" className="social-links-f">
              <AiFillYoutube />
            </Link>
            <Link to={LINKEDIN_URL} target="_blank" className="social-links-f">
              <BiLogoLinkedin />
            </Link>
          </div>
        </section>
      </footer>
    </>
  );
};

export default Footer;
